module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-valors-passion.6ab69c2d.svg";